import { RouteData } from '@sitecore-content-sdk/nextjs';
import { normalizeGuid } from '../string-utils';

/**
 * Template utility functions to check if a route template ID matches a specific template ID
 */

/**
 * Checks if a route matches a specific template ID
 * @param route - The route data to check
 * @param templateId - The template ID to match against
 * @returns True if the route matches the template ID
 */
export function isTemplate(route: RouteData, templateId: string): boolean {
  return normalizeGuid(route?.templateId) === normalizeGuid(templateId);
}
